import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal }          from '@ng-bootstrap/ng-bootstrap';

import { ApiService }      from '../api/api.service';
import { CompanyService }  from '../companies/company.service';
import { MessagesService } from '../messages/messages.service';
import { SessionService }  from '../sessions/session.service';
import { TemplateModel }   from '../templates/typings/template';

@Component({
  selector   : 'wor-company-lists-template',
  template: require('./company-lists.template.component.html')
})
export class CompanyListsTemplateComponent implements OnInit {
  @Input() template: TemplateModel;

  regoLabel: string;

  constructor (
    public activeModal: NgbActiveModal,
    private apiService: ApiService,
    private companyService: CompanyService,
    private messagesService: MessagesService,
    private sessionService: SessionService
  ) {}

  ngOnInit (): void {
    this.regoLabel = this.companyService.company?.company_variable_fields?.plate_number_name
      || this.sessionService.countrySettings().rego_label;

    if (this.template.wording_type === 'sms') {


      this.filterHtml();


      };


    }

  filterHtml (): void {


    this.template.wording = this.template.wording
      ? String(this.template.wording).replace(/<[^>]+>/gm, '')
      : '';


  }

  onWordingChange (): void {
    if (this.template.wording_type === 'sms' && this.template.wording && this.template.wording.length > 160) {

      this.template.wording = this.template.wording.substring(0, 160);

      };

    }

  save (): void {
    const method = this.template.id ? 'patch' : 'post';
    const url    = this.template.id ? '/templated_wording' : '/templated_wordings';

    this.apiService[method](url, this.template, 'templated_wording')
      .then((template: TemplateModel) => {
        this.activeModal.close(template);
      })
      .catch(err => {
        this.messagesService.error(err);
      });
  }
}
